import type { MetaFunction } from 'react-router'
import AboutPage from '~/pages/AboutPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'About Us | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'S.J.S. Technology — founded in 2024 in Bengaluru. We bring VICTORY digital printing machines and VisionJet inks with transparent pricing and 24/7 support.',
  },
  { property: 'og:title', content: 'About Us | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/about' },
]

export default function About() {
  return <AboutPage />
}
